import classnames from 'classnames';

import { Box, RadiusSize } from '../Box';
import { Typography } from '../Typography';
import { Icon } from '../Icon';

import { useStyles } from './MediaEmpty.styles';

export type MediaEmptyVariant = 'single' | 'multiple' | 'iconOnly';

export interface MediaEmptyProps {
  height?: string | number;
  width?: string | number;
  variant?: MediaEmptyVariant;
  radius?: RadiusSize;
  testId?: string;
}

export const MediaEmpty = ({
  height = '536px',
  width = '100%',
  variant = 'single',
  radius = 's',
  testId,
}: MediaEmptyProps) => {
  const { classes } = useStyles();
  const isIconOnly = variant === 'iconOnly';

  return (
    <Box
      className={classnames(classes.root, !isIconOnly && classes.withContent)}
      height={height}
      width={width}
      radius={radius}
      testId={testId}
    >
      <Icon
        name="picture_slash_outline"
        size="32"
        color="stroke.secondary"
        className={classes.icon}
      />
      {!isIconOnly && (
        <Box className={classes.text}>
          <Typography
            variant="body3"
            color="text.light.tertirary"
            align="center"
          >
            {variant === 'multiple'
              ? 'Не удалось загрузить изображения.'
              : 'Не удалось загрузить изображение.'}
          </Typography>

          <Typography
            className={classes.secondaryText}
            variant="body3"
            color="text.light.tertirary"
            align="center"
          >
            Попробуйте обновить страницу
          </Typography>
        </Box>
      )}
    </Box>
  );
};
